/* eslint-disable */
import { generateId } from "@/utils/"
import { removeTreeNodes } from "@/utils/treeUtils"

// Official Vue compilers
const vue_2_6_11_compiler = require("vue-template-compiler")

/**
 * compiler for version 2_6_11
 * @param {string} vueTemplate
 */
const compiler2_6_11 = ({ vueTemplate }) => {
	// TODO: retun error code
	if (!vueTemplate) return []

	// https://github.com/vuejs/vue/blob/dev/flow/compiler.js
	const templateContent = vue_2_6_11_compiler.parseComponent(vueTemplate)?.template?.content

	// If no vue template, return
	// TODO: should return status isSuccess false and error code that template part is broken
	if (!templateContent) return []

	let compiled

	try {
		compiled = vue_2_6_11_compiler.compile(templateContent)
	} catch (e) {
		compiled = { ast: [] }
		// TODO: handle displaying of errors, possible this util should return status, payload and possible error messages
		console.error("compileVueTemplateToEditorAst error", e)
	}

	const moveConditionalNodes = (arr, parent = null) => {
		arr.forEach((node, index) => {
			// TODO: handle scopedSlots
			// if (node?.scopedSlots) console.log({ node })
			// // If there are scoped slots, move them to node.children
			// if (node?.scopedSlots?.default) node.children.unshift(node?.scopedSlots?.default)

			// If there are if else block statements, vue parses it and saves into the array ifConditions
			// We have to move all nodes of the ifConditions array into node.children so that we can process this properly
			// If we don't do this, we don't get v-else-if and v-else nodes as those are saved only in ifConditions and they are
			// not node.children
			if (node?.ifConditions?.length > 0) {
				// Insert v-else-if and v-else elements on index position int parent.children
				const nodesToInsert = node.ifConditions.filter(item => item?.block?.elseif || item?.block?.else).map(item => item.block)
				if (parent && parent.children) parent.children.splice(index + 1, 0, ...nodesToInsert)
			}
			if (node?.children?.length) moveConditionalNodes(node.children, node)
		})
	}

	// Remove circular structures specific for vue AST
	// - parent
	// - ifConditions
	// TODO: there might be more
	const removeCircularDependenciesAndAppendProperties = (arr, parent) => {
		arr.forEach(node => {
			const nodeId = generateId() // id for the editor
			node.id = nodeId

			// Remove circular dependencies
			node.parent = null
			node.ifConditions = null
			node.scopedSlots = null

			// If node is just text node, assign content property on parent and put the node into the array of nodes to be removed
			if (node.type > 1) {
				parent.content = node.text ?? ""
				nodeIdsToRemove.push(nodeId)
				return
			}

			// If node is not a text node
			node.component = node.tag
			delete node.tag

			if (node?.children?.length) removeCircularDependenciesAndAppendProperties(node.children, node)
		})
	}

	let editorAst = [compiled?.ast ?? []]
	const nodeIdsToRemove = []

	moveConditionalNodes(editorAst)
	removeCircularDependenciesAndAppendProperties(editorAst)
	editorAst = removeTreeNodes({ nodeIds: nodeIdsToRemove, tree: editorAst }) // Remove all text nodes
	return editorAst
}

/**
 * Versioned compilers
 */
const compilersProvider = {
	"2.6.11": compiler2_6_11
}

/**
 * compileVueTemplateToEditorAst
 * @param {string} vueTemplate
 * @param {string} version
 */
export default ({ vueTemplate, version = "" }) => {
	const compiler = compilersProvider[version]
	if (!compiler) throw new Error(`There is no compiler for Vue of version ${version} available`)

	return compiler({ vueTemplate })
}
